// extracted by mini-css-extract-plugin
export default {"filters-bar":"filters-bar_filters-bar__ZlcaG"};